module.exports = __webpack_public_path__ + "media/images/icons/icons_small/11_heartbullet2-4becdb4864a0f0ac714b35a9fb8c67a9.png";